/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { StructureDamage } from '../model/models';
import { StructureDamageEntryDetails } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface StructureDamageServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get Structure Damages Entry Details
     * Returns a list of structure damages for a specific stucture_damage_id
     * @param id id for StructureDamagesEntryDetails
     */
    getStructureDamageEntryDetails(id: number, extraHttpRequestParams?: any): Observable<StructureDamageEntryDetails>;

    /**
     * Get Structure Damages
     * Returns a list of structure damages for a specific stucture_damage_id
     * @param id id for StructureDamages
     */
    getStructureDamagesByStructureDamageIdOrderyByEntryDatetimeDesc(id: number, extraHttpRequestParams?: any): Observable<StructureDamage>;

}
